// Gardırop & Dolaplar Mock Data
// Yatak odası vestiyer, antre dolabı, giyinme odası takibi

export const gardropSiparisler = [
    {
        id: 'gd-001', siparisTarihi: '2026-01-14', teslimTarihi: '2026-02-05', tedarikci: 'Bellona',
        tedarikciFirmaId: 'f-070', tur: 'Yatak Odası Gardırop', model: 'Sürgülü 240cm', renk: 'Beyaz/Ceviz',
        miktar: 8, birim: 'adet', birimFiyat: 18000, toplamFiyat: 144000, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 4, insaatId: 'c1', blokAdi: 'A Blok',
        olcu: '240x60x220 cm', malzeme: 'MDF Lam / Ayna Kapaklı',
        not: 'Master yatak odası gardıropları', createdAt: '2026-01-14T09:00:00Z', updatedAt: '2026-02-08T14:00:00Z',
    },
    {
        id: 'gd-002', siparisTarihi: '2026-01-14', teslimTarihi: '2026-02-05', tedarikci: 'Bellona',
        tedarikciFirmaId: 'f-070', tur: 'Yatak Odası Gardırop', model: 'Sürgülü 180cm', renk: 'Beyaz/Ceviz',
        miktar: 8, birim: 'adet', birimFiyat: 14000, toplamFiyat: 112000, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 3, insaatId: 'c1', blokAdi: 'A Blok',
        olcu: '180x60x220 cm', malzeme: 'MDF Lam',
        not: '2. yatak odası gardıropları', createdAt: '2026-01-14T09:30:00Z', updatedAt: '2026-02-08T15:00:00Z',
    },
    {
        id: 'gd-003', siparisTarihi: '2026-01-15', teslimTarihi: '2026-02-07', tedarikci: 'Modoko Mobilya',
        tedarikciFirmaId: 'f-071', tur: 'Antre Dolabı', model: 'Portmanto + Ayakkabılık', renk: 'Beyaz',
        miktar: 8, birim: 'adet', birimFiyat: 8500, toplamFiyat: 68000, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 4, insaatId: 'c1', blokAdi: 'A Blok',
        olcu: '120x35x200 cm', malzeme: 'MDF Lam',
        not: 'Ayna + portmanto + ayakkabılık', createdAt: '2026-01-15T10:00:00Z', updatedAt: '2026-02-10T11:00:00Z',
    },
    {
        id: 'gd-004', siparisTarihi: '2026-01-16', teslimTarihi: null, tedarikci: 'Bellona',
        tedarikciFirmaId: 'f-070', tur: 'Yatak Odası Gardırop', model: 'Sürgülü 240cm', renk: 'Antrasit/Ceviz',
        miktar: 8, birim: 'adet', birimFiyat: 19000, toplamFiyat: 152000, durum: 'bekliyor',
        montajDurumu: 'bekliyor', montajlanan: 0, insaatId: 'c1', blokAdi: 'B Blok',
        olcu: '240x60x220 cm', malzeme: 'MDF Lam / Ayna Kapaklı',
        not: 'B Blok iç işleri bitmeli', createdAt: '2026-01-16T11:00:00Z', updatedAt: '2026-01-16T11:00:00Z',
    },
    {
        id: 'gd-005', siparisTarihi: '2026-01-17', teslimTarihi: null, tedarikci: 'Linea Mobilya',
        tedarikciFirmaId: 'f-054', tur: 'Giyinme Odası', model: 'Walk-in Closet (Özel)', renk: 'Ceviz/Beyaz',
        miktar: 4, birim: 'adet', birimFiyat: 35000, toplamFiyat: 140000, durum: 'uretim',
        montajDurumu: 'bekliyor', montajlanan: 0, insaatId: 'c2', blokAdi: 'A Blok',
        olcu: 'Özel Ölçü', malzeme: 'MDF Lake + Aydınlatma',
        not: 'Dubleks dairelerin giyinme odası', createdAt: '2026-01-17T14:00:00Z', updatedAt: '2026-01-25T10:00:00Z',
    },
    {
        id: 'gd-006', siparisTarihi: '2026-01-18', teslimTarihi: null, tedarikci: 'Modoko Mobilya',
        tedarikciFirmaId: 'f-071', tur: 'Antre Dolabı', model: 'Minimal Portmanto', renk: 'Antrasit',
        miktar: 12, birim: 'adet', birimFiyat: 9000, toplamFiyat: 108000, durum: 'bekliyor',
        montajDurumu: 'bekliyor', montajlanan: 0, insaatId: 'c2', blokAdi: 'A-B Blok',
        olcu: '100x35x200 cm', malzeme: 'MDF Lam',
        not: 'Tüm standart daireler', createdAt: '2026-01-18T09:00:00Z', updatedAt: '2026-01-18T09:00:00Z',
    },
    {
        id: 'gd-007', siparisTarihi: '2026-01-19', teslimTarihi: null, tedarikci: 'Bellona',
        tedarikciFirmaId: 'f-070', tur: 'Yatak Odası Gardırop', model: 'Sürgülü 270cm', renk: 'Beyaz Lake',
        miktar: 12, birim: 'adet', birimFiyat: 24000, toplamFiyat: 288000, durum: 'bekliyor',
        montajDurumu: 'bekliyor', montajlanan: 0, insaatId: 'c2', blokAdi: 'A-B Blok',
        olcu: '270x60x220 cm', malzeme: 'MDF Lake / Ayna Kapaklı',
        not: 'Premium dairelerin master gardırobu', createdAt: '2026-01-19T10:00:00Z', updatedAt: '2026-01-19T10:00:00Z',
    },
    {
        id: 'gd-008', siparisTarihi: '2026-01-20', teslimTarihi: null, tedarikci: 'Bellona',
        tedarikciFirmaId: 'f-070', tur: 'Yatak Odası Gardırop', model: 'Sürgülü 180cm', renk: 'Beyaz Lake',
        miktar: 12, birim: 'adet', birimFiyat: 16000, toplamFiyat: 192000, durum: 'bekliyor',
        montajDurumu: 'bekliyor', montajlanan: 0, insaatId: 'c2', blokAdi: 'A-B Blok',
        olcu: '180x60x220 cm', malzeme: 'MDF Lake',
        not: '2. yatak odası', createdAt: '2026-01-20T11:00:00Z', updatedAt: '2026-01-20T11:00:00Z',
    },
];

// Gardırop türleri
export const gardropTurleri = [
    { key: 'Yatak Odası Gardırop', label: 'Yatak Odası Gardırop', aciklama: 'Sürgülü/menteşeli' },
    { key: 'Antre Dolabı', label: 'Antre Dolabı', aciklama: 'Portmanto + ayakkabılık' },
    { key: 'Giyinme Odası', label: 'Giyinme Odası', aciklama: 'Walk-in closet sistemi' },
];

// İstatistikler
export const getGardropStats = (insaatId) => {
    const filtered = insaatId
        ? gardropSiparisler.filter(s => s.insaatId === insaatId)
        : gardropSiparisler;

    const toplamKalem = filtered.length;
    const teslimEdilen = filtered.filter(s => s.durum === 'teslim').length;
    const montajlanan = filtered.reduce((acc, s) => acc + (s.montajlanan || 0), 0);
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);

    return { toplamKalem, teslimEdilen, montajlanan, toplamMaliyet };
};

// Helper
export const getGardropByInsaat = (insaatId) => {
    if (!insaatId) return gardropSiparisler;
    return gardropSiparisler.filter(s => s.insaatId === insaatId);
};
